// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { css } from "styled-components";

const xPartNumberStyle: {
    label: TypographyPresentationProps;
    value: TypographyPresentationProps;
} = {

    label: {
        size: fontConfig.singleLineSmall.size,
        weight: fontConfig.weight.medium,
        transform: "capitalize",
        lineHeight: fontConfig.singleLineSmall.lineHeight,
        css: css`
            line-height: ${fontConfig.singleLineSmall.lineHeight}
            letter-spacing: 0;
            margin-right: 4px;
            margin-bottom: 0;
            flex-shrink: 0;
            display: inline-block;
            &:after {
                content: ":";
            }
            `,
    },
    value: {
        weight: fontConfig.weight.regular,
        size: fontConfig.singleLineSmall.size,
        lineHeight: fontConfig.singleLineSmall.lineHeight,
        css: css`
            letter-spacing: 0;
        `,
    },
};

export { xPartNumberStyle };

